<template>
  <div id="app">
    <!--<img id="banner" class="no_print" src="@/assets/trailerLookUpBanner.jpg" alt="Trailer Look Up">-->
    <div id="banner" v-if="this.$route.name !== 'unitNumberSearchPage' && this.$route.name !== 'vinNumberSearchPage' " class="no_print">Trailer Registration Printing Direct ChassisLink Inc</div>
    <nav-bar class="no_print" v-if="this.$route.name !== 'loginPage' && this.$route.name !== 'unitNumberSearchPage' && this.$route.name !== 'vinNumberSearchPage'"></nav-bar>
    <router-view class="routerView"/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@import './style/main.scss';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: aliceblue;
}

html{
  background: aliceblue;
}

.routerView{
  padding: 40px;
}

#banner{
  width: 100%;
  background: #337ab7;
  color: #f5f5f5;
  font-size: xx-large;
  padding: 20px;
  text-align: left;
  font-style: italic;
  font-weight: bold;
  text-shadow: 2px 2px #000000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue